import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Modal, Row, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import { GaEvent } from "../App";
import addLogo from "../assets/plus.png";
import { utilities } from "../components/utilities";
import {
  ADD_CATEGORY,
  GET_COURSE_STATIC_DATA
} from "../constants/urlConstants";

const Category = () => {
  return (
    <Container className="main-container">
      <Row>
        <Col>
          <CategoryPanel />
        </Col>
      </Row>
    </Container>
  );
};

const CategoryPanel = () => {
  const [category, setCategory] = useState("");
  const [isLoading, setLoading] = useState(null);
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [CategoryName, setCategoryName] = useState();
  const [refreshKey, setRefreshKey] = useState(0);
  const [isRedundant, setRedundantCourse] = useState(false);

  const reset = () => {
    setValidated(false);
    setCategoryName('');
  };

  useEffect(() => {
    loadStaticData();
  }, [refreshKey]);

  const loadStaticData = async () => {
    try {
      setLoading(true);
      let result = await axios.get(GET_COURSE_STATIC_DATA);
      if (result) {
        if (result.data.errorType === "Error") {
          utilities.showToast(result.data.errorMessage);
        } else {
          setCategory(result.data.filter((x) => x.type === "Category"));
        }
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    const form = e.currentTarget;
    let dataToCheck = category?.filter(courseData => courseData.description.toLowerCase() === CategoryName.toLowerCase());
    if (dataToCheck.length > 0) {
      setRedundantCourse(true)
      e.preventDefault();
      e.stopPropagation();
      setLoading(false);
    } else {
      setRedundantCourse(false)
      if (form.checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();
        setLoading(false);
      } else {
        e.preventDefault();
        const payload = {categoryName: CategoryName};
        axios.post(ADD_CATEGORY, payload).then((res) => {
            if (res.data.errorType === "Error") {
              utilities.showToast(res.data.errorMessage);
            } else if (res.data.affectedRows > 0) {
              GaEvent("Category", "New Category Added", CategoryName);
              utilities.showToast(
                "Added " + res.data.affectedRows + " New Category!!"
              );
              reset();
            } else if (res.data.errorMessage) {
              utilities.showToast(res.data.errorMessage);
            }
            setRefreshKey((oldKey) => oldKey + 1);
            setLoading(false);
          }).catch((err) => {
            console.log("err", err);
            setLoading(false);
          });
        setShow(false);
      }
      setValidated(true);
    }
  };


  return (
    <>
      {isLoading && isLoading === true && <>
        <Row>
          <Col>
            <div className="d-flex justify-content-center align-items-center" style={{ height: '30rem' }}>
              <Spinner animation="grow" variant="primary" />
            </div>
          </Col>
        </Row>
      </>}
      {!isLoading && isLoading === false && (
        <Container>
          <div>
            <i
              className="fa fa-plus-circle fa-2x add-logo"
              onClick={handleShow}
              src={addLogo}
            />
            <Modal show={show} onHide={handleClose}>
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title>Add Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group controlId="formBasicCategoryName">
                    <Form.Label>Category Name</Form.Label>
                    <Form.Control
                      type="name"
                      maxLength={100}
                      value={CategoryName}
                      onChange={(e) => {
                        setCategoryName(e.target.value);
                        setRedundantCourse(false)
                      }}
                      autoComplete="off"
                      required
                    />
                    {isRedundant && (
                      <Form.Text>
                        <div class="text-danger">The Category already Exists!</div>
                      </Form.Text>
                    )}
                    <Form.Control.Feedback type="invalid">
                      Category Name is mandatory
                    </Form.Control.Feedback>
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                  <Button variant="primary" type="submit">
                    Save
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
          </div>
          <p className="mt-5 mb-4 mx-0">Categories for Trainings and Courses. Manage Category.</p>
          <table
            id="my-courses-list"
            className="table table-bordered table-striped"
          >
            <thead className="thead-light">
              <tr>
                <th>Category</th>
              </tr>
            </thead>
            <tbody>
              {category && category.length > 0 ? (
                category.map((item) => {
                  return (
                    <tr>
                      <td>
                        <span className="vertical-sub">{item.description}</span>
                        <span className="float-right">
                          <EditAction item={item} onSave={() => setRefreshKey((oldKey) => oldKey + 1)} />
                          <DeleteAction item={item} onDelete={() => setRefreshKey((oldKey) => oldKey + 1)} />
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <h2>No Category added.</h2>
              )}
            </tbody>
          </table>
        </Container>
      )}
    </>
  );
};

const EditAction = ({item, onSave}) => {
  const [name, setName] = useState(item.description);
  const [show, setShow] = useState(false);
  const [btnText, setBtnText] = useState('Save');
  const [isSaving, setSaving] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSubmit = (e) => {
    disableSave(true);
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      disableSave(false);
    } else {
      const payload = { categoryId: item.id, categoryName: name };
      axios.put(ADD_CATEGORY, payload).then((res) => {
        disableSave(false);
        handleClose();
        onSave();
        if (res.data.errorType === 'Error' || res.data.errorMessage) {
          utilities.showToast(res.data.errorMessage);
        } if (res.data.affectedRows > 0) {
          GaEvent("Category", "Saved Category", name);
          utilities.showToast("Category Saved Successfully!");
        }
      }).catch((err) => {
        disableSave(false);
        console.log("err", err);
      });
    }
    setValidated(true);
  };


  const disableSave = (state) => {
    setBtnText(state ? 'Saving' : 'Save');
    setSaving(state);
  }

  return (
    <>
      <i className="fa fa-edit fa-lg cursor-pointer mx-2" onClick={handleShow} />
      <Modal show={show} onHide={handleClose} contentClassName="w-100">
        <Form onSubmit={handleSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formBasicCompetencyName">
              <Form.Label>Category</Form.Label>
              <Form.Control type="name"
                maxLength={100}
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoComplete="off"
                required />
              <Form.Control.Feedback type="invalid">
                Category is mandatory
              </Form.Control.Feedback>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>Cancel</Button>
            <Button variant="success" type="submit" disabled={isSaving}>{btnText}</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

const DeleteAction = ({ item, onDelete }) => {
  const [show, setShow] = useState(false);
  const [btnText, setBtnText] = useState('Delete');
  const [isSaving, setSaving] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDelete = (e) => {
    disableSave(true);
    if (item && item.id && item.description) {
      const payload = { categoryId: item.id };
      axios.delete(ADD_CATEGORY , {data: payload}).then((res) => {
        disableSave(false);
        handleClose();
        onDelete();
        if (res.data.errorType === 'Error' || res.data.errorMessage) {
          utilities.showToast(res.data.errorMessage);
        } else if (res.data.affectedRows === 0) { 
          utilities.showToast(`Category ${item.description} cannot be deleted.`);
        } else if (res.data.affectedRows > 0) {
          GaEvent("Category", "Removed Category", item.description);
          utilities.showToast(`${item.description} category removed successfully.`);
        }
      }).catch((err) => {
        disableSave(false);
        console.log("err", err);
      });
    } else {
      disableSave(false);
      handleClose();
      utilities.showToast("Category details not found.");
    }
  };

  const disableSave = (state) => {
    setBtnText(state ? 'Deleting' : 'Delete');
    setSaving(state);
  }

  return (
    <>
      <i className="fa fa-trash fa-lg cursor-pointer" onClick={handleShow} />
      <Modal show={show} onHide={handleClose} contentClassName="w-100">
        <Modal.Header closeButton>
          <Modal.Title>Delete Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure want to delete the <b>{item.description}</b> category?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="danger" disabled={isSaving} onClick={handleDelete}>{btnText}</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUserDetail: state.CurrentUserReducer.currentUserDetail,
  };
};
export default connect(mapStateToProps)(Category);
